import * as React from 'react';
import DirectionsRun from '@material-ui/icons/DirectionsRun';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
	value?: number;
}

const TotalActiveCoachesCard = (props: Props) => {
	const { value } = props;
	const translate = useTranslate();
	return (
		<CardWithIcon
			to="/marathons"
			icon={DirectionsRun}
			title={translate('TOTAL_ACTIVE_MARATHONS')}
			subtitle={value || '---'}
		/>
	);
};

export default TotalActiveCoachesCard;
